<template>
  <div>
    <form-field-input
      label="Label"
      v-model="form.label"
      :validation-errors="validationErrors.label"
    ></form-field-input>

    <form-field-switch
      label="Mark As Default"
      v-model="form.default"
      :validation-errors="validationErrors.default"
      description='Turn on if you want this tag to be set as default when a "Next Contact At" task is created'
      small-label
    ></form-field-switch>
  </div>
</template>

<script>
import {FormMixin} from "./forms.mixin";

export default {
  name: "TagTaskForm",
  props: ['formData'],
  mixins: [FormMixin],
  data() {
    return {
      form: {},
      validationErrors: {},
      defaultForm: {
        market_id: this.$store.state.market.market.id,
        label: '',
        default: false,
      },
    }
  },
  created() {
    this.form = (this.formData) ? this.$utils.clone(this.formData) : this.$utils.clone(this.defaultForm);
  },
  computed: {
    activeTask() {
      return null;
    },
  },
  methods: {
    update() {
      return this.$api.tags.update(this.form)
        .then((res) => {
          this.$buefy.toast.open({
            message: 'Tag was updated',
            type: 'is-success'
          });

          return res;
        });
    },
    create() {
      if (this.activeTask) {
        this.form.task_id = this.activeTask.id
      }

      return this.$api.tags.createTaskTag(this.form)
        .then((res) => {
          this.$buefy.toast.open({
            message: res.data,
            type: 'is-success'
          });

          return res;
        });
    },
    delete() {
      return this.$api.tags.delete(this.form.id)
        .then((res) => {
          this.$buefy.toast.open({
            message: 'Tag was archived',
            type: 'is-success'
          });

          return res;
        });
    },
  },
}
</script>

<style scoped>

</style>
